import styled from 'styled-components';

export const Wrapper = styled.div`
    height: 100%;
    padding: 0px 10px;

    .udesk-qa-ui-tabs-bar {
        background: #fff !important;
    }

    .udesk-qa-ui-tabs-nav {
        background: #fff !important;
        padding-left: 0px !important;
        height: 38px !important;
    }

    .udesk-qa-ui-tabs-nav-list {
        margin-left: 0px !important;
    }

    .udesk-qa-ui-tabs-content {
        height: 100% !important;
    }
`;

export const Content = styled.div`
    padding: 10px 0px;
    height: ${(porps) => (porps.height ? porps.height + 'px' : '100%')};
    overflow-y: auto;
    overflow-x: hidden;
`;
